import PackageDetails from "@/features/packages/components/PackageDetails";
import { useParams } from "react-router-dom";
import ThreeDotLoader from '@shared/components/ThreeDotLoader';
import { usePackageByIdQuery } from "@/features/packages/hooks/usePackages";
import { toast } from "sonner";
import HeadLayout from "@shared/layouts/HeadLayout";
import { PackagesActionsDropdownMenu } from "../components/MenuActions";
import { useTranslation } from "react-i18next";
import { useAuth } from '@features/auth/contexts/AuthContext';
import { AddTrackingNumber, UpdatePackagesStatus } from "..";

const PackageDetailsPage = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { auth, isAdmin } = useAuth();
  const { data: packageItem, isLoading, isError } = usePackageByIdQuery(id);

  if (isError) {
    toast.error("Error fetching package", {
      duration: 5000,
    });
  }
  return (
    <>
      {packageItem && !isError && !isLoading && (
        <>
          <HeadLayout title={t("packages.packageDetails")}>
            <PackagesActionsDropdownMenu pkg={packageItem} />
            {isAdmin && (
              <div className="flex flex-col lg:flex-row gap-2 items-center justify-start">
                <UpdatePackagesStatus
                  packageId={packageItem?._id}
                  reference={packageItem.reference}
                  status={packageItem.status}
                />
                <AddTrackingNumber packageId={packageItem._id} />
              </div>
            )}
          </HeadLayout>
          <div className="rounded-xl">
            {isLoading && (
              <div className="flex items-center justify-center">
                <ThreeDotLoader size="md" />
              </div>
            )}
            {isError && !isLoading && <p>Error fetching package</p>}
            {packageItem && !isError && !isLoading && (
              <PackageDetails packageItem={packageItem} />
            )}
          </div>{" "}
        </>
      )}
    </>
  );
};

export default PackageDetailsPage;
